<div class="popup" [class.visible]="args" [class.tooltip]="args?.tooltip" [style.left.px]="args?.x" [style.top.px]="args?.y">
    <div class="popup-text">
        {{args?.text}}
    </div>
    <div class="popup-buttons" *ngIf="args?.buttons">
        <div class="popup-button" *ngFor="let btn of args?.buttons" [style.background]="btn.color" (click)="clickButton(btn)">{{btn.text}}</div>
    </div>
</div>